export class CooperativaDepositoFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getAllDeposits(filter) {
    return this.instance.get(`v1/rastreabilidade/cooperativa`, {
      params: filter || null,
    });
  }

  getDepositById(id, filter) {
    return this.instance.get(`v1/rastreabilidade/cooperativa/${id}`, {
      params: filter || null,
    });
  }

  createDeposit(data) {
    return this.instance.post(`v1/rastreabilidade/cooperativa`, data);
  }

  updateDeposit(id, data) {
    return this.instance.put(`v1/rastreabilidade/cooperativa/${id}`, data);
  }

  deleteDeposit(id) {
    return this.instance.delete(`v1/rastreabilidade/cooperativa/${id}`);
  }
}

export default (...params) => new CooperativaDepositoFactory(...params);
